// Scroll Monitor
window.scrollr = require("scrollMonitor")

// Autohide menu
import Headroom from 'headroom.js';

var $smenu = $('.headroom'),
    navtimer;
if($smenu.length>0) {
  var headroom = new Headroom($smenu[0],{
    'offset': 200,
    'tolerance': 0
  });
  headroom.init();

  // Show submenu
  var $mnbar = $smenu.find('.menubar'),
      $navbar = $smenu.find('.navbar');
  $smenu.find('.menu-links a').mouseenter(function() {
    clearTimeout(navtimer);

    $smenu.find('.menu-links a').removeClass('active');
    $mnbar.find('.megamenu').hide();
    $navbar.find('.navbar-nav').hide();

    $(this).addClass('active');
    $($(this).data('target')).css('display','flex');
  });

  // Hide submenu
  $smenu.mouseleave(function() {
    navtimer = setTimeout(function () {
      $smenu.find('.menu-links a').removeClass('active');
      $mnbar.find('.megamenu').hide();
      $navbar.find('.navbar-nav').hide();
    }, 500);
  });
}

// OnoffCanvas
import OnoffCanvas from 'onoffcanvas';

var $canvas = $('#sprdCanvas');
if($canvas.length>0) {
  var onoff = new OnoffCanvas($canvas[0])
  .on('show.onoffcanvas', function () {
    console.log('Show OnoffCanvas');
    
  }).on('hide.onoffcanvas', function () {
    console.log('Hide Onoffcanvas');
    
  });

  $canvas.find('.mask').click(function(){
    console.log('Click Canvas Mask');
    onoff.hide();
  });
}

// Floating menu, sidebar
var $menu = $('#centerMenu'),
    $sidebar = $('#sidebar .wrapper'),
    $footer = $('footer');
var watcher = [], padtop = 20;

function InitScrollr() {
  console.log('Init Scrollr');

  // Floating menu
  if($smenu.length>0) {
    var $header = $smenu.parent();
    $header.height($smenu.outerHeight());
  }
  else {
    var $header = $menu.parent();
    $header.height(
      $header.css('height','auto').height()
    );
  }
  
  // Menubar
  var mbWatcher = scrollr.create($menu);
  watcher.push(mbWatcher);
  mbWatcher.lock();
  mbWatcher.stateChange(function () {
    $menu.toggleClass('fixed', this.isAboveViewport)
  });
  if (mbWatcher.isAboveViewport) {
    $menu.addClass('fixed');
  }

  // Sidebar (Large Screen only)
  if($sidebar.length>0 && $(window).width()>991) {
    var fixpad = padtop;
    if($smenu.length>0) fixpad += $smenu.outerHeight();
    else fixpad += $menu.outerHeight();

    $sidebar.parent()
      .width($sidebar.width())
      .height($sidebar.outerHeight(true));
    $sidebar
      .width($sidebar.width())
      .css({
        'top': fixpad+'px',
        'bottom': -fixpad+'px'
      });

    var sbWatcher = scrollr.create($sidebar, {
      top: fixpad
    });
    watcher.push(sbWatcher);

    sbWatcher.lock();
    sbWatcher.stateChange(function() {
      if(this.isAboveViewport) {
        if(!ftWatcher.isAboveViewport) $sidebar.addClass('fixed');
      }
      else {
        $sidebar.removeClass('fixed');
      }
    });

    // Watch an area above the footer as tall as the sidebar + menu
    var ftWatcher = scrollr.create($footer, {
      top: $sidebar.outerHeight(true) + fixpad
    });
    watcher.push(ftWatcher);

    ftWatcher.fullyEnterViewport(function() {
      if (ftWatcher.isAboveViewport) {
        $sidebar.removeClass('fixed').addClass('btm');
      }
    });
    ftWatcher.partiallyExitViewport(function() {
      if (!ftWatcher.isAboveViewport) {
        $sidebar.addClass('fixed').removeClass('btm');
      }
    });

    if(sbWatcher.isAboveViewport) {
      $sidebar.addClass('fixed');
    }
    if (ftWatcher.isAboveViewport) {
      $sidebar.removeClass('fixed').addClass('btm');
    }
  }
}

function ResetScrollr() {
  console.log('Reset Scrollr');
  
  // Reset Canvas on Desktop
  if($(window).width()>991) {
    if ($smenu.length > 0) {
      $smenu.find('.menu-links a').removeClass('active');
      $mnbar.find('.megamenu').hide();
      $navbar.find('.navbar-nav').hide();
    }
    if ($canvas.length > 0) onoff.hide(); 
  }
  
	// Destroy all watcher
	$.each(watcher, function (no, itm) {
		itm.destroy();
	});

  // Floating menu
  $menu.parent().height('auto');
  $menu.removeClass('fixed');
  $smenu.parent().height('auto');

  // Floating sidebar
  $sidebar.parent().width('').height('auto');
  $sidebar.width('').css({'top':'', 'bottom':''});
  $sidebar.removeClass('fixed btm');
  
	// Reinit scroll
  InitScrollr();
}

InitScrollr();
$(window).on('load resize', ResetScrollr);


// NavDrawer
var $drawer = $('#drawer');
if ($drawer.length > 0) {
  var mtpl = $menu.find('.navbar-nav').html();
  $drawer.find('.navdrawer-nav').html(mtpl);
}

// Menu Dropdown
$('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
  var $el = $(this);
  var $parent = $(this).offsetParent(".dropdown-menu");
  if (!$(this).next().hasClass('show')) {
    $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
  }
  var $subMenu = $(this).next(".dropdown-menu");
  $subMenu.toggleClass('show');

  $(this).parent("li").toggleClass('show');
  $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e){
    $('.dropdown-menu .show').removeClass("show");
  });

  if($(window).width()>991) { // Menu desktop
    if (!$parent.parent().hasClass('navbar-nav')) {
      $el.next().css({
        "top": $el[0].offsetTop,
        "left": $parent.outerWidth() - 4
      });
    }
  }
  else { // Menu mobile
    if (!$parent.parent().hasClass('navdrawer-nav')) {
      $el.next().css({
        "top": $el[0].offsetTop+$el.outerHeight(),
        "left": 0
      });
    }
  }

  return false;
});



// WEBPACK FOOTER //
// ./src/floatbar.js